export const uk = {
    delete: 'Удалить'
};
